/**
 * Budgets Service Hooks
 * React hooks for accessing budget management services.
 */
import { useCCMS } from '../useCCMS';
/** Access all budget-management services. */
export function useBudgetsServices() {
    const { services } = useCCMS();
    if (!services?.budgets) {
        throw new Error('Budgets services not available. Ensure CCMSProvider is configured.');
    }
    return services.budgets;
}
export function useBudgetService() {
    return useBudgetsServices().budget;
}
export function useBudgetAllocationService() {
    return useBudgetsServices().budgetAllocation;
}
export function useBudgetItemService() {
    return useBudgetsServices().budgetItem;
}
export function useBudgetCategoryService() {
    return useBudgetsServices().budgetCategory;
}
export function useBudgetReleaseService() {
    return useBudgetsServices().budgetRelease;
}
export function useBudgetChangeRequestService() {
    return useBudgetsServices().budgetChangeRequest;
}
export function useBudgetApprovalService() {
    return useBudgetsServices().budgetApproval;
}
export function useBudgetCheckService() {
    return useBudgetsServices().budgetCheck;
}
export function useBudgetTransactionService() {
    return useBudgetsServices().budgetTransaction;
}
export function useBudgetAlertService() {
    return useBudgetsServices().budgetAlert;
}
export function useBudgetAlertThresholdService() {
    return useBudgetsServices().budgetAlertThreshold;
}
export function useBudgetDashboardService() {
    return useBudgetsServices().budgetDashboard;
}
export function useBudgetSettingService() {
    return useBudgetsServices().budgetSetting;
}
export function useBudgetTypeService() {
    return useBudgetsServices().budgetType;
}
export function useBudgetStatusService() {
    return useBudgetsServices().budgetStatus;
}
export function useBudgetFundingSourceTypeService() {
    return useBudgetsServices().budgetFundingSourceType;
}
export function useBudgetTransactionTypeService() {
    return useBudgetsServices().budgetTransactionType;
}
export function useBudgetTransactionSourceService() {
    return useBudgetsServices().budgetTransactionSource;
}
export function useBudgetApprovalStatusService() {
    return useBudgetsServices().budgetApprovalStatus;
}
export function useBudgetHealthStatusService() {
    return useBudgetsServices().budgetHealthStatus;
}
export function useBudgetAmountInputTypeService() {
    return useBudgetsServices().budgetAmountInputType;
}
export function useBudgetChangeRequestTypeService() {
    return useBudgetsServices().budgetChangeRequestType;
}
export function useBudgetReleaseValueTypeService() {
    return useBudgetsServices().budgetReleaseValueType;
}
/** v3 — forecasting: burn rate, pace, projected exhaustion. Deterministic, not model output. */
export function useBudgetForecastService() {
    return useBudgetsServices().budgetForecast;
}
/** v3 — the anomaly review queue. */
export function useBudgetAnomalyService() {
    return useBudgetsServices().budgetAnomaly;
}
/** v3 — saved Report Builder configurations. */
export function useBudgetReportService() {
    return useBudgetsServices().budgetReport;
}
//# sourceMappingURL=useBudgetsServices.js.map